import * as tslib_1 from "tslib";
var ɵ0 = function (value) {
    if (typeof value === 'boolean') {
        return +value ? '1' : '0';
    }
    return value;
};
var defaultOptions = {
    showLeafArrayIndexes: true,
    includeNullValues: true,
    mapping: ɵ0
};
function isJsonObject(val) {
    return !Array.isArray(val) && typeof val === 'object' && !!val && !(val instanceof Blob);
}
export function objToFormData(jsonObject, options) {
    if (options === void 0) { options = {}; }
    var mergedOptions = tslib_1.__assign({}, defaultOptions, options);
    return convertRecursively(jsonObject, mergedOptions);
}
function convertRecursively(jsonObject, options, parentKey, carryFormData) {
    var formData = carryFormData || new FormData();
    var index = 0;
    for (var key in jsonObject) {
        if (jsonObject.hasOwnProperty(key)) {
            var propName = parentKey || key;
            var value = options.mapping(jsonObject[key]);
            if (parentKey && isJsonObject(jsonObject)) {
                propName = parentKey + '[' + key + ']';
            }
            if (parentKey && Array.isArray(jsonObject)) {
                if (Array.isArray(value) || options.showLeafArrayIndexes) {
                    propName = parentKey + '[' + index + ']';
                }
                else {
                    propName = parentKey + '[]';
                }
            }
            if (Array.isArray(value) || isJsonObject(value)) {
                convertRecursively(value, options, propName, formData);
            }
            else if (value instanceof FileList) {
                for (var j = 0; j < value.length; j++) {
                    formData.append(propName + '[' + j + ']', value.item(j));
                }
            }
            else if (value instanceof Blob) {
                formData.append(propName, value, value['name']);
            }
            else if (((value === null && options.includeNullValues) || value !== null) && value !== undefined) {
                formData.append(propName, value);
            }
        }
        index++;
    }
    return formData;
}
export { ɵ0 };
